import { useRef } from 'react';
import { Link, Panel, PanelType } from '@fluentui/react';
import { FluentProvider, webLightTheme } from '@fluentui/react-components';
import { People24Regular } from '@fluentui/react-icons';
import {
  PagedDataGrid,
  type IPagedDataGridRefType,
  type DataGridColumn,
} from '@moko/ui';
import { getContractors, IContractor } from '../../services/contractorService';

export interface IContractorSelectorProps {
  isOpen: boolean;
  hideContractorSelector: any;
  onContractorSelected: (id: number, name: string) => void;
}

type IContractorItem = IContractor & {
  [key: string]: any;
};

const ContractorSelector = (props: IContractorSelectorProps) => {
  const pagedDataGridRef = useRef<IPagedDataGridRefType>(null);

  const columns: DataGridColumn<IContractorItem>[] = [
    {
      key: 'id',
      name: 'Id',
      width: 50,
      renderCell: (item) => (
        <Link
          key={item.id}
          onClick={() => {
            props.onContractorSelected(item?.id, item?.name ?? '');
          }}
        >
          {item.id}
        </Link>
      ),
    },
    {
      key: 'code',
      name: 'Code',
      width: 125,
    },
    {
      key: 'name',
      name: 'Name',
      width: 250,
    },
  ];

  return (
    <Panel
      isLightDismiss
      isOpen={props.isOpen}
      onDismiss={props.hideContractorSelector}
      closeButtonAriaLabel="Close"
      type={PanelType.medium}
      headerText="Pick contractor for selected work"
    >
      <FluentProvider theme={webLightTheme}>
        <div style={{ paddingTop: 12 }}>
          <PagedDataGrid<IContractorItem>
            ref={pagedDataGridRef}
            columns={columns}
            getAction={async (
              abortController,
              pageSize,
              pageNo,
              orderBy,
              search
            ) => {
              const data = await getContractors(
                abortController,
                pageSize,
                pageNo,
                orderBy,
                search
              );
              return {
                ...data,
                items: data.items as IContractorItem[],
              };
            }}
            pageSize={10}
            searchThreshold={3}
            loadingConfig={{
              message: 'Loading contractors...',
              icon: (
                <People24Regular
                  style={{ width: 125, height: 125, color: 'lightgray' }}
                />
              ),
            }}
          />
        </div>
      </FluentProvider>
    </Panel>
  );
};

export default ContractorSelector;
